<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>消息</el-breadcrumb-item>
          <el-breadcrumb-item>收件箱</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">订单编号:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入订单编号"
                  clearable
                  v-model="queryInfo.orderId"
                  size="small"
                  v-on:click.self="searchList"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">用户ID:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入用户ID"
                  clearable
                  v-model="queryInfo.createUserName"
                  size="small"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">类型:</div>
              <div class="flex1">
                <el-select
                  v-model="queryInfo.messageType"
                  placeholder="请选择类型"
                  size="small"
                  clearable
                >
                  <el-option
                    v-for="item in messageTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">发送开始日:</div>
              <div class="flex1">
                <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeStart"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </div>
            </el-col>
          </el-row>
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">发送结束日:</div>
              <div class="flex1">
                <el-date-picker
                  clearable
                  v-model="queryInfo.createTimeEnd"
                  type="date"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">标题:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入标题"
                  clearable
                  v-model="queryInfo.remindingTitle"
                  size="small"
                  v-on:click.self="searchList"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">内容:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入内容"
                  clearable
                  v-model="queryInfo.remindingContent"
                  size="small"
                  v-on:click.self="searchList"
                  @keyup.enter.native="searchList"
                >
                </el-input>
              </div>
            </el-col>
          </el-row>
        </el-collapse>
        <el-row class="search-row">
          <el-col :span="16" class="display-row">
            <div class="search-btn-container search-btn-container-status">
              <el-button
                class="search-btn  btn-white"
                :class="{ lxBtnGreenDeep: curIndex === 3 }"
                @click="changeTab(3)"
                >全部</el-button
              >
              <el-button
                class="search-btn  btn-white"
                :class="{ lxBtnGreenDeep: curIndex === 0 }"
                @click="changeTab(0)"
                >未读<span class="lx-red"
                  >({{ messageCount.notReadCount }})</span
                ></el-button
              >
              <el-button
                class="search-btn btn-white"
                :class="{ lxBtnGreenDeep: curIndex === 4 }"
                @click="changeTab(4)"
                >@我的<span class="lx-red"
                  >({{ messageCount.responsibleCount }})</span
                ></el-button
              >
              <el-button
                class="search-btn btn-white"
                :class="{ lxBtnGreenDeep: curIndex === 1 }"
                @click="changeTab(1)"
                >已读未回复<span class="lx-red"></span
              ></el-button>
              <el-button
                class="search-btn btn-white"
                :class="{ lxBtnGreenDeep: curIndex === 2 }"
                @click="changeTab(2)"
                >已回复<span class="lx-red"></span
              ></el-button>
            </div>
          </el-col>
          <el-col :span="8" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="queryInfoClear"
                >重置</el-button
              >
              <el-button class="search-btn btn-blue" @click="searchList()"
                >搜索</el-button
              >
              <el-button class="search-btn btn-blue" @click="deleteRow()"
                >批量已读</el-button
              >
              <el-button class="search-btn btn-blue" @click="readAll"
                >全部已读</el-button
              >
              <el-button class="search-btn btn-blue" @click="exportAction"
              >导出</el-button
              >
              <el-button
                class="search-btn btn-blue"
                v-if="!isActive"
                type="primary"
                icon="el-icon-arrow-down"
                alt=""
                @click="isActive = !isActive"
                >展开</el-button
              >
              <el-button
                class="search-btn btn-green"
                v-if="isActive"
                icon="el-icon-arrow-up"
                alt=""
                @click="isActive = !isActive"
                >收起</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle"
          :data="messageList"
          border
          height="550"
          @selection-change="handleSelectionChange"
        >
          <el-table-column align="center" type="selection" fixed> </el-table-column>
          <el-table-column
            align="center"
            type="index"
            label="序号"
            width="40"
            fixed
          ></el-table-column>
          <el-table-column label="操作" align="center" width="80">
            <template v-slot="scope">
              <div class="btn-row">
                <el-button
                  class="list-btn btn-green"
                  @click="reply(scope.row)"
                  v-if="
                    btnReplyFlag == scope.row.replyFlag &&
                    scope.row.createUserName != 'system'
                  "
                >
                  回复
                </el-button>
              </div>
              <div class="btn-row">
                <el-button
                  class="list-btn btn-blue"
                  @click="read(scope.row)"
                  v-if="scope.row.status == '0'"
                >
                  已读
                </el-button>
              </div>
              <div class="btn-row">
                <el-button
                  class="list-btn btn-blue"
                  @click="handleDetail(scope.row)"
                >
                  详情
                </el-button>
              </div>
              <div class="btn-row">
                <el-button
                  v-if="isManage"
                  class="list-btn btn-blue"
                  @click="call(scope.row)"
                >
                  @ID
                </el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="125"
            prop="replyFlag"
            :index="indexMethod"
            sortable
            label="消息状态"
            align="center"
          >
            <template v-slot="scope">
              <el-select
                v-model="scope.row.status"
                placeholder="请选择"
                size="small"
                :disabled="scope.row.createUserName == 'system'"
                @change="(val) => onChange(val, scope.row)"
              >
                <el-option
                  v-for="item in messageStatusList"
                  :key="item.data"
                  :label="item.name"
                  :value="item.data"
                >
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column width="250" prop="replyPicture" label="图片">
            <template slot-scope="scope">
              <el-row>
                <el-col
                  :span="8"
                  v-for="item in getFileList(scope.row.replyPicture)"
                  :key="item"
                  style="text-align: center;"
                >
                  <img
                    @click="imgclick(item, true)"
                    v-if="item && item.length > 0"
                    :src="item"
                    alt=""
                    class="list-image more-image"
                  />
                  <!--                  <img v-else src="../../assets/images/default.png" alt="" class="list-image">-->
                </el-col>
              </el-row>
            </template>
          </el-table-column>
          <el-table-column width="150" prop="video" label="mp4">
            <template #default="{ row }">
              <video width="100%" height="auto" controls v-if="row.video">
                <source :src="row.video" type="video/mp4" />
                您的浏览器不支持Video标签。
              </video>
            </template>
          </el-table-column>
          <el-table-column
            width="100"
            prop="messageType"
            align="center"
            label="类型"
          >
            <template v-slot="scope">
              {{ typeDetailShow(scope.row.messageType) }}
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            prop="orderId"
            align="center"
            label="订单编号"
          >
            <template v-slot="scope">
              <el-link @click="toOrderDetail(scope.row)" :underline="false">{{
                scope.row.orderId
              }}</el-link>
            </template>
          </el-table-column>
          <el-table-column width="100" prop="createUserName" label="用户ID">
            <template v-slot="scope">
              {{
                scope.row.createUserName === "system"
                  ? ""
                  : scope.row.createUserName
              }}
            </template>
          </el-table-column>
          <el-table-column
            width="160"
            prop="createTime"
            sortable
            :index="indexMethod"
            align="center"
            label="发送日"
          >
            <template v-slot="scope">
              {{ scope.row.createTime | dateFormatToSecond }}
            </template>
          </el-table-column>
          <el-table-column
            width="150"
            prop="orderId"
            align="center"
            label="担当者ID"
          >
            <template v-slot="scope">
              {{ scope.row.responsibleUserName }}
            </template>
          </el-table-column>
          <el-table-column
            width="130"
            prop="remindingTitle"
            align="center"
            label="标题"
          >
          </el-table-column>
          <el-table-column prop="remindingContent" label="内容" width="180">
            <template v-slot="scope">
              <div v-html="scope.row.remindingContent"></div>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" width="200" label="附件">
            <template v-slot="scope">
              <span
                v-for="(item,index) in getAttachment(scope.row.attachment)"
                :key="index"
              >
                <a target="_blank" :href="item.url">{{ item.name }}</a
                ><br />
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100, 200]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </table-con>

    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image" />
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
    <!-- 详情 -->
    <el-dialog title="信息详情" :visible.sync="detailFlag" width="1400px">
      <el-table
        :header-cell-style="tableStyle.headerStyle"
        :cell-style="tableStyle.cellStyle"
        :data="firstList"
        border
      >
        <el-table-column label="操作" align="center" width="120" fixed>
          <template v-slot="scope">
            <div class="btn-row">
              <el-button
                class="list-btn btn-green"
                @click="reply(scope.row)"
                v-if="
                  btnReplyFlag == scope.row.replyFlag &&
                  scope.row.createUserName != 'system'
                "
              >
                回复
              </el-button>
            </div>
            <div class="btn-row">
              <el-button
                class="list-btn btn-blue"
                @click="read(scope.row)"
                v-if="btnReadFlag == scope.row.status"
              >
                已读
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          prop="replyFlag"
          :index="indexMethod"
          sortable
          label="消息状态"
          align="center"
          fixed
        >
          <template v-slot="scope">
            {{ getMessageStatus(scope.row.status) }}
          </template>
        </el-table-column>
        <el-table-column prop="replyPicture" width="250" label="图片">
          <template slot-scope="scope">
            <el-row :gutter="12">
              <el-col
                :span="8"
                v-for="(item,index) in getFileList(scope.row.replyPicture)"
                :key="index"
              >
                <img
                  @click="imgclick(item, true)"
                  v-if="item && item.length > 0"
                  :src="item"
                  alt=""
                  class="list-image more-image"
                />
                <!--                <img v-else src="../../assets/images/default.png" alt="" class="list-image">-->
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="video" width="150" label="mp4">
          <template #default="{ row }">
            <video width="100%" height="auto" controls v-if="row.video">
              <source :src="row.video" type="video/mp4" />
              您的浏览器不支持Video标签。
            </video>
          </template>
        </el-table-column>
        <el-table-column prop="messageType" align="center" label="类型">
          <template v-slot="scope">
            {{ typeDetailShow(scope.row.messageType) }}
          </template>
        </el-table-column>
        <el-table-column prop="orderId" align="center" label="订单编号">
          <template v-slot="scope">
            <el-link @click="toOrderDetail(scope.row)" :underline="false">{{
              scope.row.orderId
            }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="用户ID">
          <template v-slot="scope">
            {{
              scope.row.createUserName === "system"
                ? ""
                : scope.row.createUserName
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          width="160"
          sortable
          :index="indexMethod"
          align="center"
          label="发送日"
        >
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column prop="remindingTitle" align="center" label="标题">
        </el-table-column>
        <el-table-column width="200" prop="remindingContent" label="内容">
          <template v-slot="scope">
            <div v-html="scope.row.remindingContent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" width="200" label="附件">
          <template v-slot="scope">
            <span
              v-for="(item,index) in getAttachment(scope.row.attachment)"
              :key="index"
            >
              <a target="_blank" :href="item.url">{{ item.name }}</a
              ><br />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div class="title">历史对话</div>
      <el-table
        :header-cell-style="tableStyle.headerStyle"
        :cell-style="tableStyle.cellStyle"
        :data="historyMessageList"
        border
        height="550px"
      >
        <el-table-column label="发件人" prop="sender" align="center" fixed>
          <template v-slot="scope">
            <div v-if="scope.row.sender == 1">平台</div>
            <div v-if="scope.row.sender == 0">客户</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="replyFlag"
          :index="indexMethod"
          sortable
          label="消息状态"
          align="center"
          width="100"
          fixed
        >
          <template v-slot="scope">
            {{ getMessageStatus(scope.row.status) }}
          </template>
        </el-table-column>
        <el-table-column prop="replyPicture" width="250" label="图片">
          <template slot-scope="scope">
            <el-row :gutter="12">
              <el-col
                :span="8"
                v-for="(item,index) in getFileList(scope.row.replyPicture)"
                :key="index"
              >
                <img
                  @click="imgclick(item, true)"
                  v-if="item && item.length > 0"
                  :src="item"
                  alt=""
                  class="list-image more-image"
                />
                <!--                <img v-else src="../../assets/images/default.png" alt="" class="list-image">-->
              </el-col>
            </el-row>
          </template>
        </el-table-column>
        <el-table-column prop="video" width="150" label="mp4">
          <template #default="{ row }">
            <video width="100%" height="auto" controls v-if="row.video">
              <source :src="row.video" type="video/mp4" />
              您的浏览器不支持Video标签。
            </video>
          </template>
        </el-table-column>
        <el-table-column prop="messageType" align="center" label="类型">
          <template v-slot="scope">
            {{ typeDetailShow(scope.row.messageType) }}
          </template>
        </el-table-column>
        <el-table-column prop="orderId" align="center" label="订单编号">
          <template v-slot="scope">
            <el-link @click="toOrderDetail(scope.row)" :underline="false">{{
              scope.row.orderId
            }}</el-link>
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="用户ID">
          <template v-slot="scope">
            {{
              scope.row.createUserName === "system"
                ? ""
                : scope.row.createUserName
            }}
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          width="160"
          sortable
          :index="indexMethod"
          align="center"
          label="发送日"
        >
          <template v-slot="scope">
            {{ scope.row.createTime | dateFormatToSecond }}
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          prop="remindingTitle"
          align="center"
          label="标题"
        >
        </el-table-column>
        <el-table-column width="200" prop="remindingContent" label="内容">
          <template v-slot="scope">
            <div v-html="scope.row.remindingContent"></div>
          </template>
        </el-table-column>
        <el-table-column prop="fileName" width="200" label="附件">
          <template v-slot="scope">
            <span
              v-for="(item,index) in getAttachment(scope.row.attachment)"
              :key="index"
            >
              <a target="_blank" :href="item.url">{{ item.name }}</a
              ><br />
            </span>
          </template>
        </el-table-column>
      </el-table>
      <div style="text-align: right; margin-top: 15px">
        <el-button class="form-btn btn-blue" @click="detailFlag = false"
          >确定</el-button
        >
      </div>
    </el-dialog>

    <MessageTip
      title="回复"
      :visiable.sync="isVisiable"
      :userName="replyMessageInfo.createUserName"
      :id="replyMessageInfo.id"
      :messageType="getMessageTypeStr(replyMessageInfo.messageType)"
      :orderNo="replyMessageInfo.orderId"
      httpUrl="cms/inBox/reply"
      @confirm="onConfirmMsg"
    ></MessageTip>

    <!-- 分配用户 -->
    <el-dialog title="分配用户" :visible.sync="distributionVisible" width="30%">
      <el-form label-width="120px" class="add-role-form">
        <el-form-item label="担当：">
          <el-select
            v-model="message.responsibleUserId"
            filterable
            placeholder="输入用户名进行搜素"
          >
            <el-option
              v-for="item in staffList"
              :key="item.userId"
              :label="item.userName"
              :value="item.userId"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="form-btn btn-gray"
          @click="distributionVisible = !distributionVisible"
          >取 消</el-button
        >
        <el-button class="form-btn btn-blue" @click="confirmDistribution"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import tableCon from "../../views/tableContainer";
import MessageTip from "@/components/MessageTip/index2";

export default {
  components: { tableCon, MessageTip },
  data() {
    return {
      message: {},
      isActive: false,
      curIndex: 3, // 默认选中第0个
      visible: false,
      imgurl: "",
      detailFlag: false,
      firstList: [],
      historyMessageList: [],
      listObj: [],
      imgDataObj: {
        policy: "",
        signature: "",
        key: "",
        ossaccessKeyId: "",
        dir: "",
        host: "",
        timeStamp: "",
      },
      distributionVisible: false,
      fileList: [],
      messageStatusList: [],
      staffList: [],
      btnReplyFlag: 0,
      btnReadFlag: 0,
      replyInfo: {
        remindingContent: "",
        remindingTitle: "",
        replyPicture: "",
        imgFileList: [],
        imgFileListStr: "",
        attachment: "",
      },
      rules: {
        remindingTitle: [
          { required: true, message: "请输入标题", trigger: "blur" },
        ],
        remindingContent: [
          { required: true, message: "请输入回复内容", trigger: "blur" },
        ],
      },
      queryInfo: {
        createUserName: "",
        orderId: "",
        messageType: "",
        createTimeStart: "",
        createTimeEnd: "",
        replyFlag: "",
        remindingTitle: "",
        remindingContent: "",
        pageSize: 10,
        pageNum: 1,
      },
      messageCount: {
        total: 0,
        replyCount: 0,
        notReplyCount: 0,
      },
      // dateRangeValue: [],
      replyMessageInfo: {}, //回复页面显示表格所在行内容
      splitDialogVisible: false,
      dialogVisible: false,
      messageTypeOptions: [
        {
          value: "1",
          label: "订单消息",
        },
        {
          value: "3",
          label: "普通消息",
        },
        {
          value: "4",
          label: "订单修改",
        },
        {
          value: "5",
          label: "批次消息",
        },
        {
          value: "6",
          label: "不良消息",
        },
      ],
      id: "",
      messageList: [],
      dialogFormVisible: false,
      replyDialogVisible: false,
      total: 0,
      isVisiable: false, // 消息提醒弹框
      multipleSelection: [],
    };
  },
  methods: {
    getMessageStatus(status){
      return this.messageStatusList[status]?.name || ''
    },
    toVideo(row) {
      window.open(row.video, "_blank");
    },
    getMessageTypeStr(type){
      let messageTypeArr = [
        "",
        "订单消息",
        "其他消息",
        "普通消息",
        "订单修改",
        "批次消息",
        "不良消息",
      ];
      return messageTypeArr[Number(type)] || ''
    },
    async getStaffs() {
      const { data: res } = await this.$http.get("emp/empSystemManage/listAll");
      this.staffList = res.data;
    },
    async confirmDistribution() {
      const params = {
        id: this.message.id,
        responsibleUserId: this.message.responsibleUserId,
        responsibleUserName: this.staffList.find(
          (item) => item.userId === this.message.responsibleUserId
        )?.userName,
      };
      this.$http.post("cms/inBox/updateMessage", params).then((res) => {
        this.distributionVisible = false;
        this.searchList();
        if (res.data.code == 200) {
          this.$message({
            type: "success",
            message: res.data.message,
          });
        } else {
          this.$message({
            type: "error",
            message: res.data.message,
          });
        }
      });
    },
    onChange(val, row) {
      this.$http
        .post("cms/inBox/updateMessage", { id: row.id, status: val })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: res.data.message,
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        });
    },
    changeTab(index) {
      this.curIndex = index;
      this.searchList();
    },
    getMessageStatusList() {
      this.$http
        .get("/order/getNameList", { params: { nameClass: "MESSAGE_STATUS" } })
        .then((res) => {
          this.messageStatusList = res.data.data;
        });
    },
    async handleDetail(row) {
      this.id = row.id;
      const { data: res } = await this.$http.get(
        "cmUser/message/queryMessageInfo/" + row.id
      );
      this.historyMessageList = res.data;
      let arr = [];
      res.data.forEach((item) => {
        if (item.id == this.id) {
          arr.push(item);
        }
      });
      this.firstList = arr;
      this.detailFlag = true;
    },
    getFileList(str) {
      if (str != null) {
        return str.split(",");
      }
      return [];
    },
    getAttachment(str) {
      if (str != null && str.length > 0) {
        return JSON.parse(str);
      }
      return [];
    },
    imgclick(url, visible) {
      this.visible = true;
      this.imgurl = url;
    },
    showImgDialog(index) {
      this.imgDialogVisible = true;
    },
    handleCurrentChange(newPage) {
      //分页
      this.queryInfo.pageNum = newPage;
      this.getMessageCount();
      this.getMessageList();
    },
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getMessageCount();
      this.getMessageList();
    },
    orderDateRange() {
      //搜索时间
    },
    indexMethod(index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },

    clearReplyForm() {
      //回复弹窗的取消按钮
      this.initReplyForm();
      this.replyDialogVisible = false;
    },
    initReplyForm() {
      //初始化回复弹窗的内容
      this.replyInfo = {
        remindingContent: "",
        remindingTitle: "",
        replyPicture: "",
        attachment: "",
      };
    },

    //查询
    searchList() {
      this.queryInfo.isResponsible = false;

      if (this.curIndex == 0) {
        this.queryInfo.status = 0;
        this.queryInfo.replyFlag = "";
      } else if (this.curIndex == 1) {
        this.queryInfo.status = 1;
        this.queryInfo.replyFlag = "0";
      } else if (this.curIndex == 2) {
        this.queryInfo.status = "";
        this.queryInfo.replyFlag = 1;
      } else if (this.curIndex == 3) {
        this.queryInfo.status = "";
        this.queryInfo.replyFlag = "";
      } else if (this.curIndex == 4) {
        this.queryInfo.status = "";
        this.queryInfo.replyFlag = "";
        this.queryInfo.isResponsible = true;
      }

      this.queryInfo.pageNum = 1;
      this.getMessageCount();
      this.getMessageList();
    },
    async exportAction () {
      this.$http({
        url: '/cms/inBox/exportAction',
        method: 'get',
        params: this.queryInfo,
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          //接口参数
        }
      }).then((res) => {
        //创建一个隐藏的a连接，
        const link = document.createElement('a');
        let blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        //设置连接
        link.href = URL.createObjectURL(blob);
        link.download = '收件箱列表.xlsx';
        document.body.appendChild(link);
        //模拟点击事件
        link.click();
      }).catch((err) => {
        console.log(err);
      })
    },
    async getMessageList() {
      //获取信息列表
      const { data: res } = await this.$http.get("cms/inBox/list", {
        params: this.queryInfo,
      });
      this.messageList = res.data.list;
      this.total = res.data.total;
    },
    async getMessageCount() {
      //获取信息列表
      const { data: res } = await this.$http.get("cms/inBox/messageCount", {
        params: this.queryInfo,
      });
      this.messageCount = res.data;
    },
    queryInfoClear() {
      //清空
      this.curIndex = "";
      this.queryInfo = {
        createTimeStart: "",
        createTimeEnd: "",
        orderId: "",
        userName: "",
        remindingTitle: "",
        remindingContent: "",
        pageSize: 10,
        pageNum: 1,
      };
      this.searchList()
      // this.dateRangeValue = [];
    },
    typeDetailShow(status) {
      let statusStr = ''
      switch (status) {
        case "1":
          statusStr =  "订单消息";
          break;
        case "2":
          statusStr =  "其他消息";
          break;
        case "3":
          statusStr = "普通消息";
          break;
        case "4":
          statusStr = "订单修改";
          break;
        case "5":
          statusStr = "批次消息";
          break;
        case "6":
          statusStr = "不良消息";
          break;
      }
      return statusStr
    },
    async read(row) {
      //已读
      var url = "cms/inBox/read";
      this.id = row.id;
      const { data: res } = await this.$http.post(url, { id: row.id });
      if (res.code == 200) {
        this.$message({
          type: "success",
          message: res.message,
        });
      } else {
        this.$message({
          type: "warning",
          message: res.message,
        });
      }
      this.getMessageCount();
      this.getMessageList();
      this.btnReadFlag == row.status;
      if (this.detailFlag) {
        const { data: res } = await this.$http.get(
          "cmUser/message/queryMessageInfo/" + this.id
        );
        this.historyMessageList = res.data;
        let arr = [];
        res.data.forEach((item) => {
          if (item.id == this.id) {
            arr.push(item);
          }
        });
        this.firstList = arr;
      }
    },
    //全部已读
    async readAll() {
      this.$confirm("确定要全部已读吗", {
        confirmButtonText: "确定",
        confirmButtonClass: "form-btn btn-blue",
        cancelButtonText: "取消",
        cancelButtonClass: "form-btn btn-gray",
        type: "warning",
      }).then(async () => {
        const { data: res } = await this.$http.post("cms/inBox/readAll", {});
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.message,
          });
        } else {
          this.$message({
            type: "warning",
            message: res.message,
          });
        }
        this.getMessageCount();
        this.getMessageList();
        this.btnReadFlag = 0;
      });
    },
    reply(row) {
      //回复
      this.replyMessageInfo = row;
      this.id = row.id;
      this.isVisiable = true;
    },
    // @ID
    call(row) {
      this.distributionVisible = true;
      this.message = row;
    },
    async onConfirmMsg() {
      this.isVisiable = false;
      if (this.detailFlag) {
        const { data: res } = await this.$http.get(
          "cmUser/message/queryMessageInfo/" + this.id
        );
        this.historyMessageList = res.data;
        let arr = [];
        res.data.forEach((item) => {
          if (item.id == this.id) {
            arr.push(item);
          }
        });
        this.firstList = arr;
      }
      this.getMessageCount();
      this.getMessageList();
    },
    replyDialogClose() {
      //关闭回复弹窗
      this.replyDialogVisible = false;
    },
    toOrderDetail(row) {
      if (row.orderId.indexOf("P") != -1) {
        //P出现
        this.$router.push({
          //装箱单
          name: "container",
          query: {
            containerBatchNo: row.orderId,
          },
        });
      } else {
        //订单详情
        this.$router.push({
          name: "orderDetail",
          query: {
            id: row.orderId,
            isEdit: "0",
          },
        });
      }
    },
    async deleteRow() {
      if (this.multipleSelection == 0) {
        this.$message.error("请至少选择一个消息");
        return;
      } else {
        this.$confirm("确定要批量已读吗？, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            const idList = this.multipleSelection.map((item) => item.id);
            await this.$http
              .post("cms/inBox/batchRead", { idList })
              .then(async () => {
                this.multipleSelection = [];
                this.$message({
                  type: "success",
                  message: "批量已读成功！",
                });
                await this.getMessageList();
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消批量已读",
            });
          });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    // dateRangeValue() {
    //   //解决时间选择器清空后 绑定值为null问题
    //   if (!this.dateRangeValue) {
    //     this.dateRangeValue = [];
    //     this.queryInfo.createTimeStart = '';
    //     this.queryInfo.createTimeEnd = '';
    //   } else {
    //     if (this.dateRangeValue.length > 0) {
    //       this.queryInfo.createTimeStart = this.dateRangeValue[0];
    //       this.queryInfo.createTimeEnd = this.dateRangeValue[1];
    //     }
    //   }
    //
    // }
  },
  computed: {
    // 当前选中数量
    selectNum() {
      return this.messageList.length;
    },
    isManage() {
      return (
        window.sessionStorage.getItem("role") == "超级管理员" ||
        window.sessionStorage.getItem("role") == "超超级管理员" ||
        window.sessionStorage.getItem("username") == "puenmy001"
      );
    },
  },
  created() {
    this.getMessageCount();
    this.getMessageList();
    this.getMessageStatusList();
    this.getStaffs();
  },
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}

.hide /deep/ .el-upload--picture-card {
  display: none;
}

.el-table .el-button--small {
  padding: 4px 10px;
}

.title {
  font-weight: bold;
  font-size: 18px;
  text-align: left;
  margin: 15px 0;
}

.upload-container .editor-slide-upload {
  margin-bottom: 20px;
}

.search-btn-container-status {
  text-align: left !important;
}

.more-image {
  margin: 5px;
}
</style>
